import React, { useEffect, useRef, useState } from "react";
import { loadMaps } from "../lib/gmaps";

const loadGoogleMaps = loadMaps;

/**
 * Places autocomplete input restricted to CH / FR / DE / IT.
 * Falls back to a plain input when the Google script fails to load.
 */
export const AddressAutocomplete = ({ value, onChange, placeholder, className, testId, inputRef }) => {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let ac;
    (async () => {
      try {
        await loadGoogleMaps();
        if (!ref.current || !window.google?.maps?.places?.Autocomplete) return;
        ac = new window.google.maps.places.Autocomplete(ref.current, {
          fields: ["formatted_address", "geometry", "name"],
          componentRestrictions: { country: ["ch", "fr", "de", "it"] },
        });
        ac.addListener("place_changed", () => {
          const p = ac.getPlace();
          const label = p.formatted_address || p.name || ref.current.value;
          const coords = p.geometry?.location
            ? { lat: p.geometry.location.lat(), lng: p.geometry.location.lng() }
            : null;
          onChange(label, coords);
        });
        setReady(true);
      } catch {
        setReady(false);
      }
    })();
    return () => {
      if (ac && window.google?.maps?.event) {
        window.google.maps.event.clearInstanceListeners(ac);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <input
      ref={(el) => { ref.current = el; if (inputRef) inputRef.current = el; }}
      value={value}
      onChange={(e) => onChange(e.target.value, null)}
      placeholder={placeholder}
      data-testid={testId}
      className={className}
      autoComplete="off"
    />
  );
};

export default AddressAutocomplete;
